import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from '@reach/router';
import {
  GET_DEMO,
  TRY_RISK_FREE,
} from '../../../../constants/Paths';
import {
  BACKGROUND_BLACK,
  BACKGROUND_LIGHT_BLACK,
  ORANGE,
  WHITE,
  BLACK,
} from '../../../../styles/Colors';
import { mobileDevice } from '../../../../constants/DeviceBreakPoints';

const styles = theme => ({
  screenContainer: {
    backgroundColor: BACKGROUND_BLACK,
    padding: '30px 20px',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down(mobileDevice)]: {
      backgroundColor: BACKGROUND_LIGHT_BLACK,
    },
  },
  mainText: {
    fontSize: 30,
    textAlign: 'center',
    fontFamily: 'Poppins, sans-serif',
    color: ORANGE,
    fontWeight: 'bold',
    lineHeight: 1.2,
    padding: '8px 0',
    margin: 20,
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 18,
      margin: 10,
    },
  },
  textContainer: {
    width: '70%',
    maxWidth: 800,
    display: 'flex',
    justifyContent: 'center',
    margin: '18px 0',
    [theme.breakpoints.down(mobileDevice)]: {
      width: '90%',
      margin: '14px 0',
    },
  },
  descriptionText: {
    fontFamily: 'Quicksand, sans-serif',
    color: WHITE,
    fontSize: 18,
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 16,
    },
  },
  rowContainer: {
    width: '100%',
    maxWidth: 1100,
    display: 'flex',
    justifyContent: 'center',
    marginTop: 30,
    [theme.breakpoints.down(mobileDevice)]: {
      width: '90%',
      marginTop: 10,
    },
  },
  buttonLikeStyle: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 16,
    color: WHITE,
    backgroundColor: ORANGE,
    borderRadius: 10,
    width: 120,
    padding: 8,
    textAlign: 'center',
    verticalAlign: 'middle',
    margin: '10px 20px',
    textDecoration: 'none',
    '&:hover': {
      color: BLACK,
    },
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 16,
      margin: 10,
      padding: '10px 6px',
    },
  },
});

const Sayings = [
  [
    'Their solution is as easy as 1-2 3:',
    '1) Stay Compliant with onboarding (OSHA, COVID-19)',
    '2) Know exactly who is onsite & contact them',
    '3) Know exactly what the critical task is and how to do it!',
  ].join('\n'),
  [
    'It is like having a dedicated 20 yr construction veteran guiding/training',
    'our green engineers through the entire construction schedule.',
  ].join(' '),
  [
    'LinkedField helps us with simple but necessary workflows of the construction site:',
    'project safety onboarding, contact list, and the items not tracked on schedules.',
    'LinkedField has made it so easy to use their solution.',
  ].join(' '),
];

const TestimonialSection = ({
  classes,
}) => {
  const renderSaying = content => (
    <div
      key={content}
      className={classes.textContainer}
    >
      <div className={classes.descriptionText}>
        {content.split('\n').map(item => (
          <div key={item}>
            {item}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className={classes.screenContainer}>
      <div className={classes.mainText}>
        What Our Users Say
      </div>
      {Sayings.map(content => renderSaying(content))}
      <div className={classes.rowContainer}>
        <Link
          className={classes.buttonLikeStyle}
          to={GET_DEMO}
        >
          Get a Demo
        </Link>
        <Link
          className={classes.buttonLikeStyle}
          to={TRY_RISK_FREE}
        >
          Try Risk-Free
        </Link>
      </div>
    </div>
  );
};

TestimonialSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TestimonialSection);
